import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 订单分页列表
export function getOrderPager(req) {
  return request({
    url: apiConfig.orderInfo.api.pager.url,
    method: "post",
    data: {
      userName: req.userName,
      examName: req.examName,
      outTradeNo: req.outTradeNo,
      tradeState: req.tradeState,
      storageStatus: req.storageStatus,
      orderStatus: req.orderStatus,
      startTime: req.startTime,
      endTime: req.endTime,
      agentId: req.agentId,
      param: req.param,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

// 订单分页列表搜索功能
export function searchOrderPager(req) {
  return request({
    url: apiConfig.orderInfo.api.searchPager.url,
    method: "post",
    data: {
      userName: req.userName,
      projectName: req.projectName,
      outTradeNo: req.outTradeNo,
      tradeState: req.tradeState,
      storageStatus: req.storageStatus,
      orderStatus: req.orderStatus,
      startDate: req.startDate,
      endDate: req.endDate,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

// 收益总览
export function getEarnings(req) {
  return request({
    url: apiConfig.orderInfo.api.earnings.url,
    method: "post",
    data: {
      agentIds: req
    }
  });
}

// 导出订单
export function downloadOrder(req) {
  return request({
    url: apiConfig.orderInfo.api.downloadOrder.url,
    method: "post",
    data: {
      userName: req.userName,
      examName: req.examName,
      outTradeNo: req.outTradeNo,
      tradeState: req.tradeState,
      startTime: req.startTime,
      endTime: req.endTime,
      agentId: req.agentId,
      param: req.param
    },
    responseType: "blob"
  });
}
